// extracted by mini-css-extract-plugin
export default {"bahasa_list_wrapper":"BahasaListStyle_bahasa_list_wrapper__p+BIP","list_item":"BahasaListStyle_list_item__grNXi","title":"BahasaListStyle_title__xNtYd"};